import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register service worker (PWA) with update detection.
// In production: register /sw.js and listen for updates.
// In dev: only register if explicitly enabled via REACT_APP_PWA_DEV=1 to avoid hot-reload conflicts.
const PWA_ACTIVE = process.env.NODE_ENV === "production" || process.env.REACT_APP_PWA_DEV === "1";
if ("serviceWorker" in navigator && PWA_ACTIVE) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Auto-check for updates every 60 minutes while the app is open
        setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
        // Forward `updatefound` to the UI via postMessage
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener("statechange", () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) {
              navigator.serviceWorker.controller.postMessage({ type: "SKIP_WAITING" });
              window.dispatchEvent(new CustomEvent("pwa:update-available"));
            }
          });
        });
      })
      .catch(() => {});
  });
}
